import React, { useEffect } from 'react';
import useCommonHooks from '../hooks/site/useCommonHooks';

export default function Common() {
  useCommonHooks();

  return <></>;
}
